/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fresh_Wide_Frog_FadeInputs */

const en_fresh_wide_frog_fade = /** @type {(inputs: Fresh_Wide_Frog_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit`)
};

const de_fresh_wide_frog_fade = /** @type {(inputs: Fresh_Wide_Frog_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearbeiten`)
};

/**
* | output |
* | --- |
* | "Edit" |
*
* @param {Fresh_Wide_Frog_FadeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fresh_wide_frog_fade = /** @type {((inputs?: Fresh_Wide_Frog_FadeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fresh_Wide_Frog_FadeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fresh_wide_frog_fade(inputs)
	return de_fresh_wide_frog_fade(inputs)
});